import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CaregiverLogsRoutingModule } from './caregiver-logs-routing.module';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MyDatePickerModule } from 'mydatepicker';
import { CaregiverLogsComponent } from './caregiver-logs.component';

@NgModule({
  declarations: [CaregiverLogsComponent],
  imports: [
    CommonModule,
    GridModule,
    CaregiverLogsRoutingModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    ReactiveFormsModule,
    FormsModule,
    MyDatePickerModule
  ],
  providers: [PageService,
    SortService,
    ResizeService,
    FilterService,
    ColumnChooserService]
})
export class CaregiverLogsModule { }
